import { useEffect, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import api from 'src/services/api';

export type PeriodoAbast = 'hoje' | 'semana' | 'mes' | 'ano';

export type AbastRecord = {
    hora: string;
    estabelecimento: string;
    placa: string;
    modelo: string;
    tipoCombustivel: string;
    litros: number;
    valorTotal: number;
    departamento: string;
    categoria: string;
    capacidadeTanque: number;
    fraude: boolean;
    tipoFraude: 'EXCESSO' | 'DUPLO' | null;
};

export type AbastResumo = {
    totalLitros: number;
    totalValor: number;
    normais: number;
    fraudes: number;
};

const emptyResumo: AbastResumo = { totalLitros: 0, totalValor: 0, normais: 0, fraudes: 0 };

export const useAbastecimentos = () => {
    const { userAgencyId } = useAuth();
    const [records, setRecords] = useState<AbastRecord[]>([]);
    const [resumo, setResumo] = useState<AbastResumo>(emptyResumo);
    const [loading, setLoading] = useState(false);
    const [periodo, setPeriodo] = useState<PeriodoAbast>('hoje');

    const fetch = (p: PeriodoAbast = periodo) => {
        if (!userAgencyId) return;
        setLoading(true);
        api.get(`/dashboard-abastecimentos/${userAgencyId}?periodo=${p}`)
            .then(res => {
                setRecords(res.data.records ?? []);
                setResumo(res.data.resumo ?? emptyResumo);
                setLoading(false);
                console.log(' 1--AbastecimentosController.fetch response:', res.data);
            })
            .catch(err => { console.error(err); setLoading(false); });
    };

    const changePeriodo = (p: PeriodoAbast) => {
        setPeriodo(p);
        fetch(p);
    };

    useEffect(() => { fetch(); }, [userAgencyId]);

    return { records, resumo, loading, periodo, changePeriodo };
};
